import { render, staticRenderFns } from "./BloodTypeDelete.vue?vue&type=template&id=761d0fa0&scoped=true&"
import script from "./BloodTypeDelete.vue?vue&type=script&lang=js&"
export * from "./BloodTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d0fa0",
  null
  
)

export default component.exports